import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { getDate } from "../../utils/date";
import Swal from "sweetalert2";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { apiRequest } from "../../utils/api";
import { Link } from "react-router-dom";

function Coupons() {
  const [name, setName] = useState("");
  const [percentage, setPercentage] = useState("");
  const [validTill, setValidTill] = useState(new Date());
  const [total, setTotal] = useState("");
  const [couponFor, setCouponFor] = useState("");
  const [coupons, setCoupons] = useState([]);

  async function submit(e) {
    e.preventDefault();

    try {
      if (!name || !percentage)
        return Alert("error", "Warning", "Please Fill Name And Percentage");
      let payload = {
        coupon: name,
        percentage,
        valid: new Date(validTill).getTime(),
        total_usage: total,
        couponFor,
      };
      let res = await apiRequest.post(`/coupon/create`, payload);
      if (res.data.status === 200) {
        window.location.reload();
      } else {
        Alert("error", "Warning", res.data.message);
      }
    } catch (error) {
      Alert("error", "Error", error.message);
    }
  }

  useEffect(() => {
    getCoupons();
    document.title = `Coupons | JDM Plates`;
  }, []);

  async function getCoupons() {
    try {
      let res = await apiRequest.get(`/coupon/all`);
      if (res.data.status === 200) {
        setCoupons(res.data.message?.filter((c) => c.status != "deleted"));
      } else {
        setCoupons([]);
        console.log(res.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const columns = [
    {
      name: "S.No",
      selector: (row, index) => <>{index + 1}</>,
    },
    {
      name: "Coupon",
      selector: (row) => (
        <>
          <p>{row.c_name}</p>
        </>
      ),
    },
    {
      name: "Percentage Off",
      selector: (row) => (
        <>
          <p>{row.c_percentage}%</p>
        </>
      ),
    },
    {
      name: "Coupon For",
      selector: (row) => (
        <>
          <p>{checkCoupanFor(row)}</p>
        </>
      ),
    },

    {
      name: "Added Date",
      selector: (row) => (
        <>
          {" "}
          <p>{getDate(row.created_at)}</p>{" "}
        </>
      ),
    },
    {
      name: "Valid Till",
      selector: (row) => (
        <p>{getDate(new Date(parseInt(row.valid_till)).toDateString())}</p>
      ),
    },
    {
      name: "Total Coupons",
      selector: (row) => (
        <>
          <p>{row.total_usage}</p>
        </>
      ),
    },
    {
      name: "Action",
      selector: (row) => (
        <>
          <div className="edit-delet">
            {row.Action}
            {/* <Link> 
                          <img src="img/trash.png" />
                        </Link> */}
            <Link to={`/edit-coupon/${row.c_name}`}>
              <img src="/img/edit.svg" />{" "}
            </Link>
            <Link onClick={() => deleteCoupon(row?.c_id)}>
              <img src="/img/trash.png" />{" "}
            </Link>
          </div>
        </>
      ),
    },
  ];

  function checkCoupanFor(row) {
    const val = couponsArr?.filter((c) => c?.value === row?.coupon_for)[0].text;
    return val;
  }

  async function deleteCoupon(coupon) {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let res = await apiRequest.delete("/coupon/delete/" + coupon);
        Swal.fire({
          position: "top-end",
          icon: "info",
          title: "Please Wait For Few Moments",
          showConfirmButton: false,
          timer: 1500,
        });
        if (res.data.status == 200) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Data Has Been Deleted",
            showConfirmButton: false,
            timer: 1500,
          });
          window?.location.reload();
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        }
      }
    });
  }

  const couponsArr = [
    {
      text: "Private Plate Discount",
      value: "plate",
    },
    {
      text: "Physical Plate Discount",
      value: "service",
    },
    {
      text: "Transfer service Discount",
      value: "fast",
    },
  ];
  return (
    <>
      <div className="main-content">
        <div className="row">
          <div className="table-title coupons-heading">
            <h2>Coupons</h2>
            <button
              //   onClick={handleButtonClick}
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
              className="btn coupon-btn"
            >
              Add Coupon
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="datatable0">
              <DataTable columns={columns} data={coupons} pagination />
            </div>
          </div>
        </div>
      </div>

      {/* modal */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Add Coupon
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label htmlFor="name">Name</label>
                <input
                  onChange={(e) => setName(e.target.value)}
                  type="text"
                  id="name"
                  className="form-control"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="percentage">Percentage</label>
                <input
                  id="percentage"
                  onChange={(e) => setPercentage(e.target.value)}
                  type="text"
                  className="form-control"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="valid">Valid Till</label>
                <div className="date-input">
                  <DatePicker
                    className="form-control"
                    selected={validTill}
                    id="valid"
                    minDate={new Date()}
                    onChange={(date) => setValidTill(date)}
                  />
                </div>
              </div>
              <div className="mb-3">
                <label htmlFor="totals">Total Number Of Coupons</label>
                <input
                  id="totals"
                  onChange={(e) => setTotal(e.target.value)}
                  type="text"
                  className="form-control"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="coupon_for">Total Number Of Coupons</label>
                <select
                  className="form-select"
                  onChange={(e) => setCouponFor(e.target.value)}
                >
                  <option selected disabled>
                    Choose Coupon For
                  </option>
                  {couponsArr?.map((c, i) => (
                    <option key={i} value={c.value}>
                      {c.text}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                onClick={submit}
                className="btn btn-primary"
              >
                Save changes
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function Alert(icon, title, text) {
  return Swal.fire({
    icon,
    title,
    text,
  });
}

export default Coupons;
